import type { Customer } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { emptyPlaceholder } from "src/common/emptyPlaceholder"
import { commonMessages } from "src/common/messages/common.messages"
import { CopyToClipboard, List } from "src/components"
import { offerMessages } from "src/screens/offers/common/offer.messages"

interface CustomerInfoProps {
	customer: Customer
}

export const CustomerInfo = ({ customer }: CustomerInfoProps) => {
	const { formatMessage } = useIntl()

	return (
		<List>
			<List.Item
				label={formatMessage(offerMessages.customerNameFieldLabel)}
				valueSingleLine
				value={customer.name || emptyPlaceholder}
			/>

			{customer.type === "CAP" && (
				<>
					<List.Item
						label={formatMessage(offerMessages.customerBusinessPartnerIdLabel)}
						valueSingleLine
						value={
							customer.businessPartnerId ? (
								<CopyToClipboard value={customer.businessPartnerId} weight="semibold" />
							) : (
								emptyPlaceholder
							)
						}
					/>

					<List.Item
						label={formatMessage(commonMessages.leadId)}
						valueSingleLine
						value={
							customer.leadId ? (
								<CopyToClipboard value={customer.leadId} weight="semibold" />
							) : (
								emptyPlaceholder
							)
						}
					/>
				</>
			)}
		</List>
	)
}
